import React, { useState, useRef, useEffect } from "react";
import "./DhenkanalNavbarPage.css";
import whatsappIcon from "../assest/whatsapp.png";

import posterimg from "../assest/bannerimg.png";


import image1 from "../assest/image1.png";
import image2 from "../assest/image2.png";
import image3 from "../assest/image3.png";
import image4 from "../assest/image4.png";
import image5 from "../assest/image5.png";
import image6 from "../assest/image6.png";
import image7 from "../assest/image7.png";
import image8 from "../assest/image8.png";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dhealnavbar from "../Navbar/dhealnavbar";

export default function DhenkanalNavbarPage(
    { toggleTheme,
        increaseFont,
        decreaseFont,
        resetFont }) {

    // ************* ADDED ONLY THIS ****************
    // const [fontSize, setFontSize] = useState(100);

    // const increaseFont = () => setFontSize(prev => Math.min(prev + 10, 150));
    // const decreaseFont = () => setFontSize(prev => Math.max(prev - 10, 70));
    // const resetFont = () => setFontSize(100);
    // const [theme, setTheme] = useState("light");

    // const toggleTheme = () => {
    //     setTheme(theme === "light" ? "dark" : "light");
    // };


    const [activePage, setActivePage] = useState("home");
    const navigate = useNavigate();
    const { t } = useTranslation();

    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const amount = 300;
            scrollRef.current.scrollBy({
                left: direction === "left" ? -amount : amount,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        const autoScroll = setInterval(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
            }
        }, 3000);

        return () => clearInterval(autoScroll);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (

        <div
            // className={`theme-${theme} DhenkanalNavbarPage-container`}
            // style={{ fontSize: "inherit" }}
            className="DhenkanalNavbarPage-container"

        >

            <Dhealnavbar
                increaseFont={increaseFont}
                decreaseFont={decreaseFont}
                resetFont={resetFont}
                toggleTheme={toggleTheme}
            />
            {/* KONARK FESTIVAL SECTION */}
            <div className="DhenkanalSecondPages-container">

                {/* LEFT — FESTIVAL POSTER */}
                <div className="DhenkanalSecondPages-left">
                    <div className="image-bannerwrapper">
                        <img
                            src={posterimg}
                            alt="Konark Festival Banner"
                            className="DhenkanalSecondPages-banner"
                        />

                        {/* TEXT INSIDE IMAGE */}
                        <div className="image-overlay-bannertext">
                            Mahima Temple, Joranda
                        </div>
                    </div>
                </div>


                {/* RIGHT — OFFICERS SECTION
                <div className="DhenkanalSecondPages-right">

                  
                    <div className="DhenkanalSecondPages-officer">
                        <img
                            src={collector}
                            alt={t("collectorName")}
                            className="DhenkanalSecondPages-officer-photo"
                        />
                        <div className="DhenkanalSecondPages-officer-text">
                            <p className="DhenkanalSecondPages-officer-name">{t("collectorName")}</p>
                            <p className="DhenkanalSecondPages-officer-title">{t("collectorTitle")}</p>
                        </div>
                    </div>

                  
                    <div className="DhenkanalSecondPages-officer">
                        <img
                            src={ips}
                            alt={t("spName")}
                            className="DhenkanalSecondPages-officer-photo"
                        />
                        <div className="DhenkanalSecondPages-officer-text">
                            <p className="DhenkanalSecondPages-officer-name">{t("spName")}</p>
                            <p className="DhenkanalSecondPages-officer-title">{t("spTitle")}</p>
                        </div>
                    </div>

                </div> */}
            </div>

            {/* TAB BUTTON SECTION */}
            <div className="tabcolpagesss-container">
                <div
                    className="tabcolpagesss-item"
                    onClick={() => window.open("https://360.dhenkanalservice.in", "_blank")}
                >
                    {t("dhenkanal360")}
                </div>
                {/*<div className="tabcolpagesss-item" onClick={() => }window.open("https://skillconnect.dhenkanalservice.in/", "_blank")>
                        {t("skillConnect")}
                    </div>*/}
                <div className="tabcolpagesss-item" >

                </div>
                <div className="tabcolpagesss-item" onClick={() => window.open("https://dashboard.dhenkanalservice.in/", "_blank")}>
                    {t("samadhan")}
                </div>
            </div>

            {/* ABOUT DHENKANAL SECTION */}
            <div className="Dhenkanalaboutpages-heading">{t("about")}</div>
            <div className="Dhenkanalaboutpages-container">


                <div className="Dhenkanalaboutpages-content">
                    <p>{t("aboutText")}</p>

                    <button
                        className="Dhenkanalaboutpages-btn"
                        onClick={() => navigate("/aboutpage")}
                    >
                        {t("readMore")}
                    </button>
                </div>
            </div>

            {/* TOURISM CARDS SLIDER */}
            <div className="Dhenkanalaboutpages-heading">{t("tourism_or")}</div>
            <div className="Tourismpagesss-container">
                <div className="Tourismpagesss-header">
                    <p className="tourismtext">{t("tourismtxt")}</p>
                </div>
            </div>
            <div className="Tourismpagesss-slider-wrapper">

                {/* Left Arrow */}
                <button
                    className="Tourismpagesss-arrow Tourismpagesss-arrow-left"
                    onClick={() => scroll("left")}
                >
                    ←
                </button>

                {/* Cards Container */}
                <div className="Tourismpagesss-cards" ref={scrollRef}>                    
                    <div className="Tourismpagesss-card">
                        <img src={image3} className="Tourismpagesss-card-image" alt="" />

                        <h3 className="Tourismpagesss-card-title">
                            {t("tourism.dandadhar_title")}
                        </h3>

                        <p className="Tourismpagesss-card-category">
                            {t("tourism.category")} : {t("tourism.dandadhar_category")}
                        </p>

                        <p className="Tourismpagesss-card-desc">
                            {t("tourism.dandadhar_desc")}
                        </p>
                    </div>

                    <div className="Tourismpagesss-card">
                        <img src={image4} className="Tourismpagesss-card-image" alt="" />

                        <h3 className="Tourismpagesss-card-title">
                            {t("tourism.kualo_title")}
                        </h3>

                        <p className="Tourismpagesss-card-category">
                            {t("tourism.category")} : {t("tourism.kualo_category")}
                        </p>

                        <p className="Tourismpagesss-card-desc">
                            {t("tourism.kualo_desc")}
                        </p>
                    </div>

                    <div className="Tourismpagesss-card">
                        <img src={image5} className="Tourismpagesss-card-image" alt="" />

                        <h3 className="Tourismpagesss-card-title">
                            {t("tourism.saptasajya_title")}
                        </h3>

                        <p className="Tourismpagesss-card-category">
                            {t("tourism.category")} : {t("tourism.saptasajya_category")}
                        </p>

                        <p className="Tourismpagesss-card-desc">
                            {t("tourism.saptasajya_desc")}
                        </p>
                    </div>  <div className="Tourismpagesss-card">
                        <img src={image6} className="Tourismpagesss-card-image" alt="" />

                        <h3 className="Tourismpagesss-card-title">
                            {t("tourism.saranga_title")}
                        </h3>

                        <p className="Tourismpagesss-card-category">
                            {t("tourism.category")} : {t("tourism.saranga_category")}
                        </p>

                        <p className="Tourismpagesss-card-desc">
                            {t("tourism.saranga_desc")}
                        </p>
                    </div>

                    <div className="Tourismpagesss-card">
                        <img src={image7} className="Tourismpagesss-card-image" alt="" />

                        <h3 className="Tourismpagesss-card-title">
                            {t("tourism.joranda_title")}
                        </h3>

                        <p className="Tourismpagesss-card-category">
                            {t("tourism.category")} : {t("tourism.joranda_category")}
                        </p>

                        <p className="Tourismpagesss-card-desc">
                            {t("tourism.joranda_desc")}
                        </p>
                    </div>

                    {/* CARD 8 */}
                    <div className="Tourismpagesss-card">
                        <img
                            src={image8}
                            className="Tourismpagesss-card-image"
                            alt={t("tourism.kapilashTemple.title")}
                        />

                        {/* Title */}
                        <h3 className="Tourismpagesss-card-title">
                            {t("tourism.kapilashTemple.title")}
                        </h3>

                        {/* Category */}
                        <p className="Tourismpagesss-card-category">
                            {t("tourism.kapilashTemple.category")}
                        </p>

                        {/* Description */}
                        <p className="Tourismpagesss-card-desc">
                            {t("tourism.kapilashTemple.description")}
                        </p>
                    </div>


                </div>

                {/* Right Arrow */}
                <button
                    className="Tourismpagesss-arrow Tourismpagesss-arrow-right"
                    onClick={() => scroll("right")}
                >
                    →
                </button>
            </div>

            {/* FOOTER */}
            <div className="footercolpagesss-container">
                <p className="footercolpagesss-text">{t("footerText")}</p>
            </div>

            {/* WHATSAPP FLOATING ICON */}
        <a
  href="https://wa.me/919237301766?text=Hello"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-float-left"
>

                <img
                    src={whatsappIcon}
                    alt="WhatsApp"
                    className="whatsapp-icon"
                />
            </a>

        </div>

    );
}
